/**
 * Чи API списку приймає фільтр «призначив» (`assignedBy`): одна пробна перевірка на сесію вкладки, а не на кожне відкриття панелі (UIUX
 * patterns/filtering, швидке поле «Призначив»). Відповідь зберігається в sessionStorage; «ні» перевіряється знову не раніше ніж за 10 хвилин —
 * після оновлення сервера поле вмикається саме. Без sessionStorage (приватний режим) — лише пам'ять сторінки.
 */
const KEY = 'po.assignedByFilter';
const RETRY_MS = 10 * 60 * 1000;

let pending: Promise<boolean> | null = null;
let memory: { ok: boolean; at: number } | null = null;

function read(): { ok: boolean; at: number } | null {
  if (memory) return memory;
  try {
    const raw = sessionStorage.getItem(KEY);
    const parsed = raw ? (JSON.parse(raw) as { ok?: unknown; at?: unknown }) : null;
    return parsed && typeof parsed.ok === 'boolean' && typeof parsed.at === 'number' ? { ok: parsed.ok, at: parsed.at } : null;
  } catch {
    return null;
  }
}

function write(ok: boolean): void {
  memory = { ok, at: Date.now() };
  try { sessionStorage.setItem(KEY, JSON.stringify(memory)); } catch { /* сховище недоступне — лишається пам'ять сторінки */ }
}

/** Відома відповідь (true / false) або undefined — ще не перевіряли чи «ні» застаріло. */
export function knownAssignedBySupport(now = Date.now()): boolean | undefined {
  const known = read();
  if (!known) return undefined;
  return known.ok || now - known.at < RETRY_MS ? known.ok : undefined;
}

/** Перевіряє підтримку один раз (паралельні виклики чекають ту саму перевірку): `run` — пробний запит списку, відмова — «не підтримується». */
export function probeAssignedBySupport(run: () => Promise<unknown>): Promise<boolean> {
  const known = knownAssignedBySupport();
  if (known !== undefined) return Promise.resolve(known);
  pending ??= run().then(() => true, () => false).then((ok) => { write(ok); pending = null; return ok; });
  return pending;
}
